import { useState, useEffect } from 'react';
export function useDeviceOrientation() {
    const getOrientation = ()=>window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
    const [orientation, setOrientation] = useState(getOrientation);
    useEffect(()=>{
        const handler = ()=>setOrientation(getOrientation());
        window.addEventListener('resize', handler);
        return ()=>window.removeEventListener('resize', handler);
    }, []);
    return orientation;
}
